import { createNavigationContainerRef } from '@react-navigation/native';
import { RootStackParamList } from './types';

export const navigationRef = createNavigationContainerRef<RootStackParamList>();

/** Navigate from anywhere, including surfaces mounted OUTSIDE the navigator.
 *
 * CORE-509 — the celebration screens moved to the app root (a level-up is a
 * platform-wide event, not a profile-page one), which puts them outside
 * `NavigationContainer`. `useNavigation` throws there; the container ref does
 * not. No-ops until the container is ready, exactly like `navigateToLogin`. */
export function navigateTo(name: string, params?: object) {
  if (navigationRef.isReady()) {
    (navigationRef.navigate as unknown as (n: string, p?: object) => void)(name, params);
  }
}

export function navigateToLogin() {
  if (navigationRef.isReady()) {
    navigationRef.reset({
      index: 0,
      routes: [{ name: 'Login' }],
    });
  }
}
